import React from "react";
import { PanelLeftOpen, PanelLeftClose } from "lucide-react";
import { useSidebar } from "./SidebarContext.jsx";

const PageHeader = ({ title }) => {
  const { isSidebarOpen, toggleSidebar } = useSidebar();

  const normalizedTitle = typeof title === "string" ? title.trim() : "";
  const hasTitle = normalizedTitle.length > 0;

  return (
    <div className={`page-header ${hasTitle ? "" : "page-header--menu-only"}`}>
      <button
        type="button"
        className="page-menu-btn"
        onClick={toggleSidebar}
        aria-label={isSidebarOpen ? "Cerrar menú" : "Abrir menú"}
      >
        {isSidebarOpen ? <PanelLeftClose size={18} /> : <PanelLeftOpen size={18} />}
      </button>

      {hasTitle ? <h1 className="page-title">{normalizedTitle}</h1> : null}
    </div>
  );
};

export default PageHeader;